module.exports = __webpack_public_path__ + "assets/img/appleWallet_btn.c0c62b85.svg";